import {useQuery} from '@tanstack/react-query';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';

const getResendTimerData = () =>
	Promise.resolve({
		timer: 300,
		startTime: Date.now(),
		isAvailable: false,
	});

export const useResendTimerQuery = () =>
	useQuery({
		queryKey: [QUERY_KEYS.RESEND_TIMER],
		queryFn: getResendTimerData,
	});
